import { countryModelData } from './models/CountriesModel'
import { AdminCountryService } from './api/AdminCountryService'

const CountryModule = {
  namespaced: true,
  state: countryModelData(),
  getters: {
    fetchCountryList: state => state.countryList,
    fetchSearchCountryList: state => state.searchCountryList
  },
  mutations: {
    setCountryList (state, data) {
      state.countryList = data.list
    },
    setEditCountryList (state, data) {
      state.countryList = data.list
    },
    setSearchCountryList (state, data) {
      state.searchCountryList = data.list
    },
    deleteCountryItem (state, data) {
      state.countryItem = data.Item
    }
  },
  actions: {
    /**
     * Get countries list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param params | object
     */
    async getCountryList ({ commit }, { resolve, reject, fetchOnlyPublished }) {
      try {
        const response = await AdminCountryService.fetchCountryList(fetchOnlyPublished)
        const { success, data } = response.data
        if (success === true) {
          commit('setCountryList', {
            list: data.list
          })
          commit('setSearchCountryList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    // get search object for country list
    async getSearchCountryList ({ commit }, { resolve, reject, fetchOnlyPublished }) {
      try {
        const response = await AdminCountryService.fetchCountryList(fetchOnlyPublished)
        const { success, data } = response.data
        if (success === true) {
          commit('setSearchCountryList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addCountryItem ({ dispatch }, { resolve, reject, formData, searchData }) {
      try {
        const response = await AdminCountryService.addCountryItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getSearchCountryList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async editCountryItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminCountryService.editCountryItem(editedData)
        const { success, data } = response.data
        if (success === true) {
          dispatch('getSearchCountryList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async searchCountryItem ({ commit }, { resolve, reject, searchData }) {
      try {
        const response = await AdminCountryService.searchCountryList(searchData)
        const { success, data } = response.data
        if (success === true) {
          commit('setCountryList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setCountryList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async validateDeleteCountryItem ({ commit }, { resolve, reject, formData }) {
      try {
        const response = await AdminCountryService.validateDeleteCountryItem(formData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteCountryItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminCountryService.deleteCountryItem(formData)
        const { success, data } = response.data
        if (success === true) {
          dispatch('getCountryList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getCountryDetailsById ({ commit }, { resolve, reject, idToGetInfo }) {
      try {
        const response = await AdminCountryService.fetchCountryDetailsById(idToGetInfo)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default CountryModule
